module.exports = __webpack_public_path__ + "img/screen.191ff3e0.png";